var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarketPlaceCloseIcon = function SvgMarketPlaceCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    d: "M20.605 0c11.379 0 20.604 9.225 20.604 20.605 0 11.379-9.225 20.604-20.604 20.604C9.225 41.209 0 31.984 0 20.605 0 9.225 9.225 0 20.605 0m7.105 13.499a1.917 1.917 0 0 0-2.711 0l-4.394 4.395L16.21 13.5a1.917 1.917 0 0 0-2.711 2.71l4.395 4.395-4.395 4.393a1.917 1.917 0 0 0 2.711 2.711l4.395-4.394 4.394 4.395a1.917 1.917 0 0 0 2.711-2.711l-4.396-4.394 4.396-4.395a1.917 1.917 0 0 0 0-2.711"
  })));
};
export default SvgMarketPlaceCloseIcon;